module.exports = __webpack_public_path__ + "img/pluto148.c6cc769f.jpg";